export var AVATAR = 'rounded-full inline-flex items-center justify-center overflow-hidden flex-shrink-0';